export type PayloadWithSignal<T = Record<string, never>> = T & {
  signal?: AbortSignal
};

export type FocusTopic = {
  id: string;
  name: string;
  createdAt: any;
  createdBy: string;
  updatedAt?: any;
  updatedBy?: string;
  canBeDeleted: boolean;
  isActive: boolean;
};

export type GetFocusTopicResponse = {
  focusTopicItems: {
    focusTopics: FocusTopic[];
  }
};

export type NewFocusTopic = {
  id?: string;
  name: string;
}

export type AddFocusTopicRequest = {
  focusTopics: [
    {
      name: string;
    }
  ]
}

export type EditFocusTopicRequest = {
  focusTopics: [
    {
      id: string;
      name: string;
    }
  ]
}

export type DeleteFocusTopicRequest = {
  focusTopicIds: string[];
}

export type ActivateFocusTopicRequest = {
  focusTopics: [
    {
      id: string;
      isActive: boolean;
    }
  ]
}
